import useAuth from "../hooks/useAuth";
import { Helmet } from "react-helmet-async";
import UserEntityTabs from "../components/pages/dashboard/UserEntityTabs";
import ProfileBasicInfo from "../components/pages/dashboard/profile/ProfileBasicInfo";
import ProfileEmailChange from "../components/pages/dashboard/profile/ProfileEmailChange";
import ProfilePasswordChange from "../components/pages/dashboard/profile/ProfilePasswordChange";
import PasskeyManager from "../components/pages/dashboard/profile/PasskeyManager";
import AppointmentsSection from "../components/pages/dashboard/entities/AppointmentsSection";
import { usePermissions } from "../utils/permissions";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { t } = useTranslation();
  const { user, customer_identification } = useAuth();
  const permissions = usePermissions(user);
  const canManageOwnerEmail = !permissions.isRoleGoverned();

  return (
    <div>
      <Helmet>
        <title>Profile | Super User Manager</title>
        <meta name="description" content="Your profile" />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_HOST_URL}/control-panel/profile`}
        />
      </Helmet>

      <div className="container mx-auto py-6">
        <h1 className="mb-6 text-xl font-semibold text-gray-900">
          {t("dashboard.profile.key1")}
        </h1>

        <div className="flex flex-col gap-5">
          <ProfileBasicInfo />

          {canManageOwnerEmail && <ProfileEmailChange />}

          <ProfilePasswordChange />

          <PasskeyManager />

          <AppointmentsSection
            customerIdentification={customer_identification}
            entityIdentification={user.entity_identification}
            userIdentification={user.user_identification}
          />

          <div className="px-3 sm:px-5 pt-5 pb-8 bg-white rounded-lg border border-gray-200 flex-col justify-start items-start gap-5 inline-flex w-full">
            <UserEntityTabs
              entity_identification={user.entity_identification}
              customerId={customer_identification}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
